import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
import { Typography, Stack } from '@mui/material'
import DashboardMainInfoItem from '../components/DashboardMainInfoItem'
import CustomersResellers from './components/CustomersResellers'
import BasicInfo from './components/BasicInfo'
import RevenueGraph from './components/RevenueGraph'
import { OrdersProps } from '.'

interface ICustomersResellersTotal {
  revenue: number | string
  numberOfOrders: number
}

interface IDashboardComponent {
  readonly isLoading: boolean
  readonly formatData: OrdersProps
  readonly customersResellersTab: 'all' | 'direct' | 'reseller'
  readonly customersResellers: any
  readonly customersResellersTotal: ICustomersResellersTotal
  readonly onChangeCustomersResellersTab: (tab: 'all' | 'direct' | 'reseller') => void
  readonly dashboardStats?: any
}

const NewDashboardComponent = ({
  isLoading,
  customersResellersTab,
  customersResellersTotal,
  customersResellers,
  onChangeCustomersResellersTab,
  dashboardStats,
}: IDashboardComponent) => (
  <Stack spacing={3}>
    <BasicInfo isLoading={isLoading} dashboardStats={dashboardStats} />
    <Stack p={3} borderRadius={4} spacing={4}>
      <Typography fontSize={16} fontWeight={600} color="primary">
        Revenue (Last 12 Months)
      </Typography>
      <RevenueGraph data={dashboardStats?.revenueChartData} />
    </Stack>
    <Stack direction="row" spacing={4}>
      <Stack flex={1} p={3} borderRadius={4} spacing={4}>
        <DashboardMainInfoItem
          isLoading={isLoading}
          title="Number of Resellers"
          value={
            dashboardStats?.numberOfResellers != null
              ? dashboardStats.numberOfResellers.toLocaleString('de-DE')
              : 0
          }
          Icon={<PeopleOutlineOutlinedIcon htmlColor="#fff" fontSize="large" />}
        />
      </Stack>
      <Stack flex={1} p={3} borderRadius={4} spacing={4}>
        <DashboardMainInfoItem
          isLoading={isLoading}
          title="Reseller Revenue"
          value={
            dashboardStats?.resellerRevenue != null
              ? `€${dashboardStats.resellerRevenue.toLocaleString('de-DE', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : 'N/A'
          }
          Icon={<HowToRegOutlinedIcon htmlColor="#fff" fontSize="large" />}
        />
      </Stack>
    </Stack>
    <CustomersResellers
      isLoading={isLoading}
      customersResellersTotal={customersResellersTotal}
      customersResellersTab={customersResellersTab}
      customersResellers={customersResellers}
      onChangeCustomersResellersTab={onChangeCustomersResellersTab}
    />
  </Stack>
)

export default NewDashboardComponent
